var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.show)?_c('div',{attrs:{"id":"preloader"}},[_c('div',{staticClass:"spinner",attrs:{"id":"status"}},[_c('div',{staticClass:"double-bounce1"}),_c('div',{staticClass:"double-bounce2"})])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }